import React from 'react'
import Icon from '../components/Icon'

const linkTypes = {
	HOME: {
		type: 'HOME',
		icon: <Icon name="whiteHomeOutline" />,
		iconActive: <Icon name="whiteHomeActive" />,
		iconDisabled: <Icon name="blackHome" />
	},
	SEARCH: {
		type: 'SEARCH',
		icon: <Icon name="whiteSearchOutline" />,
		iconActive: <Icon name="whiteSearchActive" />,
		iconDisabled: <Icon name="blackSearch" />
	},
	ADD: {
		type: 'ADD',
		icon: <Icon name="whiteCreateLargeOutline" />,
		iconActive: <Icon name="whiteCreateLargeActive" />,
		iconDisabled: <Icon name="blackCreatelarge" />
	},
	NOTIFICATIONS: {
		type: 'NOTIFICATIONS',
		icon: <Icon name="whiteNotificationsNotActive" />,
		iconNotificationsUnread: <Icon name="whiteNotificationsDot" />,
		iconActive: <Icon name="whiteNotificationsActive" />,
		iconDisabled: <Icon name="blackMessageOutline" />
	},
	USER: {
		type: 'USER',
		icon: <Icon name="whiteProfileOutline" />,
		iconActive: <Icon name="whiteProfileActive" />,
		iconDisabled: <Icon name="blackProfile" />
	}
}

export default linkTypes



// WEBPACK FOOTER //
// ./src/enums/linkTypes.js